<template>
<div class="chapter">
<div class="inner_page">
<div class="dedicationPage" id="ded01">
<a id="page05"></a>
<p class="dedicationText">To Joshua, Eliana,<br/> and, of course,<br/> Avital, my Tallulah</p>
<p class="dedicationText">In memory of Allan Saffron</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ded01.vue?35a6914a